import { defineMessages } from 'react-intl';

export const sharedMemMessages = defineMessages({
  // Form actions
  cancel: { id: 'mem_form_cancel', defaultMessage: 'Cancel' },

  // Form labels
  privateLabel: { id: 'mem_form_private_label', defaultMessage: 'Make private' },
  sensitiveLabel: { id: 'mem_form_sensitive_label', defaultMessage: 'Sensitive content' },

  // Formatting controls
  bold: { id: 'mem_format_bold', defaultMessage: 'Bold' },
  italic: { id: 'mem_format_italic', defaultMessage: 'Italic' },
});
